import { CommonModule, formatDate } from '@angular/common';
import { Component } from '@angular/core';
import { CalendarComponentDef } from '@df/ui/form/calendar.component.def';

@Component({
    selector: 'calendar',
    templateUrl: 'calendar.html',
    standalone: true,
    imports: [CommonModule]
})
export class CalendarComponent extends CalendarComponentDef {
    currentMonth?: string;
    dayLabels: string[] = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    protected override update() {
        super.update();

        if (this.monthDate) {
            this.currentMonth = formatDate(this.monthDate, 'MMMM yyyy', this.app.data.locale);
        }
    }
}
